<template>
    <span class="text-nowrap">
        <component
            :is="link ? 'router-link' : 'span'"
            v-if="modelValue"
            :to="`/clients/${modelValue.id}`"
        >
            <i
                v-if="showIcon"
                :class="icon"
            />

            {{ $filters.ellipsis(modelValue.full_name, 30) }}

            <template v-if="showCompany && modelValue.companies">
                <small
                    v-for="company in modelValue.companies"
                    :key="company.id"
                    class="text-muted mr-2"
                >
                    <i class="fa fa-building" />
                    {{ company.name }}
                </small>
            </template>
        </component>
        <template v-else>
            {{ rootvalue ? rootvalue.original_email_from : '' }}
        </template>
    </span>
</template>

<script>
export default {
    props: {
        modelValue: Object,
        rootvalue: Object,
        showCompany: {
            type: Boolean,
            default: false,
        },
        link: {
            type: Boolean,
            default: false,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        icon () {
            return 'fa fa-user';
        },
    },
};
</script>
